let api_token;

switch (window.Shopify.shop) {
  case "fostr-underscore.myshopify.com":
    api_token = "206fa93198662aeb44f1a671aa9f45f4"; // Dev Store
    break;
}

window.API_VERSION = "2023-10";
if(api_token) window.API_ACCESS = api_token;

function supportsHEVCAlpha() {
  const navigator = window.navigator;
  const ua = navigator.userAgent.toLowerCase()
  const hasMediaCapabilities = !!(navigator.mediaCapabilities && navigator.mediaCapabilities.decodingInfo)
  const isSafari = ((ua.indexOf('safari') != -1)&& (!(ua.indexOf('chrome')!= -1) && (ua.indexOf('version/')!= -1)))

  return isSafari && hasMediaCapabilities
}

function iOS() {
  return [
    'iPad Simulator',
    'iPhone Simulator',
    'iPod Simulator',
    'iPad',
    'iPhone',
    'iPod'
  ].includes(navigator.platform)
  // iPad on iOS 13 detection
  || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
}

function isIE11() {
  return !!window.navigator.userAgent.match(/Trident\/7\./,[]);
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

// button group
class ButtonGroup extends HTMLElement {
  constructor() {
    super();
    this.buttons = this.querySelectorAll(".button");
  }

  connectedCallback() {
    // check which button has bigger widht and set it to all buttons
    this.setButtonsWidth();

    // detect whhen buttons wrap and add class to parent
    this.detectWrap();
  }

  setButtonsWidth() {
    let maxWidth = 0;
    this.buttons.forEach((button) => {
      button.style.width = 'unset';
      if (button.offsetWidth > maxWidth) {
        maxWidth = button.offsetWidth;
      }
    });

    this.buttons.forEach((button) => {
      button.style.width = `${maxWidth}px`;
    });
  }

  detectWrap() {
    const observer = new ResizeObserver((entries) => {
      const parentWidth = entries[0].contentRect.width;
      const buttonsWidth = this.buttons[0].offsetWidth * this.buttons.length;

      this.setButtonsWidth();

      if (buttonsWidth + 5 > parentWidth) {
        this.classList.add("button-group--wrap");
      } else {
        this.classList.remove("button-group--wrap");
      }
    });

    observer.observe(this);
  }
}

customElements.define("button-group", ButtonGroup);

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open")
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this)
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle("disabled", value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle("disabled", value >= max);
    }
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false)
    );

    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });

    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (event.pointerType === "mouse" && !event.target.closest("deferred-media, product-model")) {

          if (event.target.tagName === "BUTTON" && event.target.dataset.mediaControl !== undefined) {
            // fix for the video media button in pdp modal
            return;
          }

          if (event.target.closest(".product-media-modal__thumbnail")) return;

          this.hide();
        }
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) {
          this.hide();
        }
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class ModalOpenerImage extends HTMLElement {
  connectedCallback() {
    this.addEventListener("click", () =>{
      this.modalId = this.getAttribute("data-modal");
      const queryEl = `modal-opener[data-modal="${this.modalId}"]`;
      this.modalOpener = document.querySelector(queryEl);
      if (!this.modalOpener) return;
      this.modalButton = this.modalOpener.querySelector("button.product__media-toggle");
      if (!this.modalButton) return;

      this.modalButton.click();
    })
  }
}

customElements.define("modal-opener-image", ModalOpenerImage);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
      if (
        deferredElement.nodeName == "VIDEO" &&
        deferredElement.getAttribute("autoplay")
      ) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class VariantSelects extends HTMLElement {
  constructor() {
    super();

    this.handleEventListeners();
  }

  handleEventListeners() {
    const self = this;
    document.querySelectorAll('.product-form__input input[type="radio"]:not(.js-tracked), .product-form__input select:not(.js-tracked)').forEach((option) => {
      option.classList.add("js-tracked");
      option.addEventListener("change", this.whichInputUpdated.bind(option));
      self.addEventListener("change", this.onVariantChange);
    });
  }

  disconnectedCallback() {
    const self = this;
    document.querySelectorAll('.product-form__input input[type="radio"], .product-form__input select').forEach((option) =>
      option.removeEventListener("change", this.whichInputUpdated.bind(option))
    );

    self.removeEventListener("change", this.onVariantChange);
  }

  whichInputUpdated(element) {
    var optionname = element.target.closest(".product-form__input").querySelector(".form__label").dataset.optionname;

    document.querySelectorAll(`.product-form__input`).forEach((option) => option.classList.remove("activeset"));
    document.querySelectorAll(`.form__label[data-optionname="${optionname}"]`).forEach((option) =>
      option.closest(".product-form__input").classList.add("activeset")
    );
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }

    var allSelectors = document.querySelectorAll(
      ".section-main-product .product__variant-selector.option-select"
    );

    allSelectors.forEach((selector) => {
      if (selector != this) {
        this.updatePairUI(selector, this);
      }
    });
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(
      `[id^="MediaGallery-${this.dataset.section}"]`
    );
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(
        `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        true
      )
    );

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    );
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(":checked").value === variant.option1
    );

    const inputWrappers = [...this.querySelectorAll(".product-form__input")];

    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked").value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.innerText = input.getAttribute("value");
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace(
          "[value]",
          input.getAttribute("value")
        );
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(
          `price-${this.dataset.section}`
        );
        const destinationSticky = document.getElementById(
          `price-${this.dataset.section}-support`
        );

        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuSource = html.getElementById(
          `Sku-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuDestination = document.getElementById(
          `Sku-${this.dataset.section}`
        );

        const stockSource = html.getElementById(`stock-${this.dataset.section}`);
        const stockDestination = document.getElementById(`stock-${this.dataset.section}`);

        if (stockSource && stockDestination) {
          stockDestination.innerHTML = stockSource.innerHTML;
        }

        const loyaltyPointsValueSource = html.getElementById(`loyalty-points-value-${this.dataset.section}`);
        const loyaltyPointsValueDestination = document.getElementById(`loyalty-points-value-${this.dataset.section}`);

        if (loyaltyPointsValueSource && loyaltyPointsValueDestination) {
          loyaltyPointsValueDestination.innerHTML = loyaltyPointsValueSource.innerHTML;
        }

        const inventorySource = html.getElementById(
          `Inventory-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const inventoryDestination = document.getElementById(
          `Inventory-${this.dataset.section}`
        );

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (source && destinationSticky)
          destinationSticky.innerHTML = source.innerHTML;

        if (inventorySource && inventoryDestination)
          inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle(
            "visibility-hidden",
            skuSource.classList.contains("visibility-hidden")
          );
        }

        const price = document.getElementById(`price-${this.dataset.section}`);
        const priceSticky = document.getElementById(
          `price-${this.dataset.section}-support`
        );

        if (price) price.classList.remove("visibility-hidden");
        if (priceSticky) priceSticky.classList.remove("visibility-hidden");

        if (inventoryDestination)
          inventoryDestination.classList.toggle(
            "visibility-hidden",
            inventorySource.innerText === ""
          );

        const addButtonUpdated = html.getElementById(
          `ProductSubmitButton-${sectionId}`
        );

        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute("disabled") : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );

    if (!productForm) return;

    const stickyAtcButton = document.getElementById(
      `sticky-${this.dataset.section}`
    );

    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    const addButtonSticky = stickyAtcButton?.querySelector('[name="add"]');
    const addButtonTextSticky = stickyAtcButton?.querySelector(
      '[name="add"] > span'
    );

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (addButtonSticky) addButtonSticky.setAttribute("disabled", "disabled");
      if (text) {
        addButtonText.textContent = text;
        if (addButtonSticky) addButtonTextSticky.textContent = text;
      }
    } else {
      addButton.removeAttribute("disabled");
      addButtonText.textContent = window.variantStrings.addToCart;

      if (addButtonSticky) {
        addButtonSticky.removeAttribute("disabled");
        addButtonTextSticky.textContent = window.variantStrings.addToCart;
      }
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const stickyAtcButton = document.getElementById(
      `sticky-${this.dataset.section}`
    );

    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');

    const addButtonSticky = stickyAtcButton?.querySelector('[name="add"]');
    const addButtonTextSticky = stickyAtcButton?.querySelector(
      '[name="add"] > span'
    );

    const price = document.getElementById(`price-${this.dataset.section}`);
    const priceSticky = document.getElementById(
      `price-${this.dataset.section}-support`
    );

    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`
    );
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;

    if (addButtonSticky)
      addButtonTextSticky.textContent = window.variantStrings.unavailable;

    if (price) price.classList.add("visibility-hidden");
    if (priceSticky) priceSticky.classList.add("visibility-hidden");

    if (inventory) inventory.classList.add("visibility-hidden");
    if (sku) sku.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  updatePairUI(paired, original) {
    var originalTagName = original.tagName.toLowerCase();
    var pairedTagName = paired.tagName.toLowerCase();
    var originalSelectedItem = "";
    var originalSelectedItemValue = "";

    if (originalTagName.includes("selects")) {
      var itemSelect = original.querySelector(".activeset select");
      originalSelectedItem = itemSelect.options[itemSelect.selectedIndex];
      originalSelectedItemValue = originalSelectedItem.value;
    } else {
      originalSelectedItem = original.querySelector(
        '.activeset input[type="radio"]:checked'
      );
      originalSelectedItemValue = originalSelectedItem.value;
    }

    if (pairedTagName.includes("selects")) {
      var event = new Event("change");
      paired.querySelector(".activeset select").value =
        originalSelectedItemValue;
      paired
        .querySelector(
          `.activeset option[data-value="${originalSelectedItemValue}"`
        )
        .click();
      paired.dispatchEvent(event);
    } else {
      paired.querySelector(
        `.activeset input[type="radio"]:checked`
      ).checked = false;
      var newTarget = paired
        .querySelector(
          `.activeset label[data-value="${originalSelectedItemValue}"`
        )
        .getAttribute("for");
      paired.querySelector(
        `.activeset input[type="radio"]#${newTarget}`
      ).checked = true;
    }
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.classList.remove("disabled");
      } else {
        input.classList.add("disabled");
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

class CustomSelect extends HTMLElement {
  constructor() {
    super();

    this.mainSelect = this.querySelector("select");
    this.mainLabel = this.querySelector("label");
    this.selectStyle = this.dataset.style || 'default';
    this.selectType = this.dataset.type || 'default';
    this.randomId = Math.random().toString(36).substring(7);

    this.selectTemplate = document.createElement("template");

    if(this.selectType === 'default') {
    this.selectTemplate.innerHTML = `
      <div id="select-${this.randomId}" class="custom-select style-${this.selectStyle}" tabindex="0" >
        <div class="select-selected" aria-role="button" aria-controls="select-${this.randomId}" aria-expanded="false"  aria-controls="select-options-${this.randomId}" >
          <div class="select-label"></div>
          <div class="selected-item"></div>
          <div class="select-arrow">
            <svg class="icon-custom-select-arrow" width="8" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0 0H8L4 6L0 0Z" fill="#111111"/>
            </svg>
          </div>
        </div>
        <div id="select-options-${this.randomId}" class="select-items select-hide" role="listbox"></div>
      </div>
    `;
    } else if (this.selectType === 'collection-sort') {
      this.selectTemplate.innerHTML = `
      <div id="select-${this.randomId}" class="custom-select style-${this.selectStyle}" tabindex="0" >
        <div class="select-selected" aria-role="button" aria-controls="select-${this.randomId}" aria-expanded="false"  aria-controls="select-options-${this.randomId}" >
          <div class="select-label"></div>
          <div class="selected-item"></div>
          <div class="select-arrow">
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M2 3H10" stroke="#111111"/>
              <path d="M8 1L10 3L8 5" stroke="#111111"/>
              <path d="M4 7L2 9L4 11" stroke="#111111"/>
              <path d="M2 9H10" stroke="#111111"/>
            </svg>
          </div>
        </div>
        <div id="select-options-${this.randomId}" class="select-items select-hide" role="listbox"></div>
      </div>
    `;
    }
  }

  connectedCallback() {
    this.select = this.selectTemplate.content.cloneNode(true);
    this.appendChild(this.select);

    this.dropdownContainer = this.querySelector(".select-items");
    this.selectSelected = this.querySelector(".select-selected");
    this.selectedItem = this.querySelector(".selected-item");
    this.customSelect = this.querySelector(".custom-select");

    // populate options
    this.populateOptions();
    // populate label if exists
    if(this.mainLabel) {
      this.populateLabel();
    }

    this.selectItems = this.querySelectorAll(".select-item");
    // set initial selected item
    this.initialSelectItem();

    this.selectSelected.addEventListener("click", () => this.toggleDropdown());
    document.addEventListener("click", (event) => this.bodyClickHandler(event));
    this.addEventListener("keyup", (event) => this.closeOnEscKey(event));
    this.addEventListener("keyup", (event) => this.openOnFocusAndEnter(event));

    //check if any item inside dropdown is focused, if not close
    this.dropdownContainer.addEventListener("focusout", (event) => {
      if (!this.contains(event.relatedTarget)) {
        this.dropdownContainer.classList.add("select-hide");
        this.removeTabIndexFromAllSelectItems();
        // set aria-expanded to false when dropdown is closed
        this.selectSelected.setAttribute("aria-expanded", "false");
      }
    });

    this.customSelect.addEventListener("focus", () => {
      this.dropdownContainer.classList.add("select-hide");
      this.removeTabIndexFromAllSelectItems();
    });

    this.customSelect.addEventListener("keydown", (event) => {
      this.listenForKeyAndScrollToItem(event);
    });
  }

  listenForKeyAndScrollToItem(event) {
    // return id dropdown is closed
    if (this.dropdownContainer.classList.contains("select-hide")) {
      return;
    };
    const key = event.key;
    // scroll to first 'select-item' that starts with the key pressed
    const firstItem = Array.from(this.selectItems).find((item) => {
      return item.innerText.toLowerCase().startsWith(key.toLowerCase());
    });
    if (firstItem) {
      firstItem.scrollIntoView({
        behavior: "instant",
        block: "start",
        inline: "start",
      });
      firstItem.focus();
    }
  }


  populateOptions() {
    // loop through options and create select items
    let selectItem;
    this.mainSelect.querySelectorAll("option").forEach((option) => {

      selectItem = document.createElement("div");
      selectItem.innerHTML = option.innerHTML;
      selectItem.classList.add("select-item");

      if (option.classList.contains("shoppable-market")) {
        selectItem.classList.add("shoppable-market");
      }

      selectItem.setAttribute("role", "option");
      selectItem.setAttribute("aria-selected", "false");

      if(option.selected) {
        selectItem.classList.add("selected");
        selectItem.setAttribute("aria-selected", "true");
      }

      this.dropdownContainer.appendChild(selectItem);

      // if option is disabled add disabled class and return
      if(option.disabled) {
        selectItem.classList.add("disabled");
        return;
      }

      selectItem.addEventListener("click", () => this.onSelectItem(option, selectItem));
      // onSelect when enter key pressed and focused
      selectItem.addEventListener("keyup", (event) => {
        if (event.key === "Enter" && option.innerHTML == document.activeElement.innerHTML) {
          this.onSelectItem(option, selectItem);
        }
      });

    });
  }

  onSelectItem(option) {
    // update selected item
    this.selectedItem.innerHTML = option.innerHTML;
    // remove selected class from all select items
    const selectedOption = this.querySelector("[selected]");
    if(selectedOption) {
      selectedOption.removeAttribute("selected");
    }

    this.selectItems.forEach((item) => item.classList.remove("selected"));
    // add selected class to the clicked item
    this.selectItems[option.index].classList.add("selected");
    // set aria-selected to false for all items
    this.selectItems.forEach((item) => item.setAttribute("aria-selected", "false"));
    // set aria-selected to true for the clicked item
    this.selectItems[option.index].setAttribute("aria-selected", "true");

    // update original select and dispatch change event
    this.mainSelect.selectedIndex = option.index;
    if(this.mainSelect.options[option.index].classList.contains("shoppable-market")) {
      this.selectedItem.classList.add("shoppable-market");
    } else {
      this.selectedItem.classList.remove("shoppable-market");
    }
    this.mainSelect.options[option.index].setAttribute("selected", "selected");
    this.mainSelect.dispatchEvent(new Event("change"));

    this.removeTabIndexFromAllSelectItems();
    this.dropdownContainer.classList.add("select-hide");

    const variantSelect = this.closest("variant-selects");
    if (variantSelect) variantSelect.onVariantChange();
  }

  populateLabel() {
    this.selectLabel = this.querySelector(".select-label");
    this.selectLabel.innerHTML = this.mainLabel.innerHTML;
  }

  initialSelectItem() {
    this.selectedItem.innerHTML = this.mainSelect.options[this.mainSelect.selectedIndex].innerHTML;
    if(this.mainSelect.options[this.mainSelect.selectedIndex].classList.contains("shoppable-market")) {
      this.selectedItem.classList.add("shoppable-market");
    }
  }

  toggleDropdown() {
    this.dropdownContainer.classList.toggle("select-hide");
    if (!this.dropdownContainer.classList.contains("select-hide")) {
      this.moveFocusToFirsItem();
      // set aria-expanded to true when dropdown is open
      this.selectSelected.setAttribute("aria-expanded", "true");
    } else {
      this.customSelect.focus();
      // set aria-expanded to false when dropdown is closed
      this.selectSelected.setAttribute("aria-expanded", "false");
    }
  }

  bodyClickHandler(event) {
    if (!this.contains(event.target)) {
      this.dropdownContainer.classList.add("select-hide");
      // set aria-expanded to false when dropdown is closed
      this.selectSelected.setAttribute("aria-expanded", "false");
    }
  }

  closeOnEscKey(event) {
    if (event.key === "Escape") {
      this.dropdownContainer.classList.add("select-hide");
      this.removeTabIndexFromAllSelectItems();
      this.customSelect.focus();
      // set aria-expanded to false when dropdown is closed
      this.selectSelected.setAttribute("aria-expanded", "false");
    }
  }

  moveFocusToFirsItem() {
    // focus first of currently selected item
    if(this.mainSelect.selectedIndex){
      this.selectItems[this.mainSelect.selectedIndex].focus();
    } else {
      this.selectItems[0].focus();
    }
  }

  addTabIndexToAllSelectItems() {
    this.selectItems.forEach((item) => item.setAttribute("tabindex", "0"));
  }

  removeTabIndexFromAllSelectItems() {
    this.selectItems.forEach((item) => item.removeAttribute("tabindex"));
  }

  openOnFocusAndEnter(event) {
    // open dropdown on focus and enter key
    if (event.key === "Enter" && this.dropdownContainer.classList.contains("select-hide") && this.customSelect === document.activeElement) {
      this.dropdownContainer.classList.remove("select-hide");
      this.moveFocusToFirsItem();
      this.addTabIndexToAllSelectItems();
      // set aria-expanded to true when dropdown is open
      this.selectSelected.setAttribute("aria-expanded", "true");
    }
  }
}

customElements.define("custom-select", CustomSelect);

// collapsible content animation

class Accordion {
  constructor(el) {
    if(document.body.classList.contains('password')) return;
    // Store the <details> element
    this.el = el;
    // Store the <summary> element
    this.summary = el.querySelector('summary');
    // Store the <div class="content"> element
    this.content = el.querySelector('.accordion__content');

    // Store the animation object (so we can cancel it if needed)
    this.animation = null;
    // Store if the element is closing
    this.isClosing = false;
    // Store if the element is expanding
    this.isExpanding = false;
    // Detect user clicks on the summary element
    this.summary.addEventListener('click', (e) => this.onClick(e));
  }

  onClick(e) {
    // Stop default behaviour from the browser
    e.preventDefault();
    // Add an overflow on the <details> to avoid content overflowing
    this.el.style.overflow = 'hidden';
    // Check if the element is being closed or is already closed
    if (this.isClosing || !this.el.open) {
      this.open();
    // Check if the element is being openned or is already open
    } else if (this.isExpanding || this.el.open) {
      this.shrink();
    }
  }

  shrink() {
    // Set the element as "being closed"
    this.isClosing = true;

    // Store the current height of the element
    const startHeight = `${this.el.offsetHeight}px`;
    // Calculate the height of the summary
    const endHeight = `${this.summary.offsetHeight}px`;

    // If there is already an animation running
    if (this.animation) {
      // Cancel the current animation
      this.animation.cancel();
    }

    // Start a WAAPI animation
    this.animation = this.el.animate({
      // Set the keyframes from the startHeight to endHeight
      height: [startHeight, endHeight]
    }, {
      duration: 400,
      easing: 'ease-out'
    });

    // When the animation is complete, call onAnimationFinish()
    this.animation.onfinish = () => this.onAnimationFinish(false);
    // If the animation is cancelled, isClosing variable is set to false
    this.animation.oncancel = () => this.isClosing = false;
  }

  open() {
    // Apply a fixed height on the element
    this.el.style.height = `${this.el.offsetHeight}px`;
    // Force the [open] attribute on the details element
    this.el.open = true;
    // Wait for the next frame to call the expand function
    window.requestAnimationFrame(() => this.expand());
  }

  expand() {
    // Set the element as "being expanding"
    this.isExpanding = true;
    // Get the current fixed height of the element
    const startHeight = `${this.el.offsetHeight}px`;
    // Calculate the open height of the element (summary height + content height)
    const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

    // If there is already an animation running
    if (this.animation) {
      // Cancel the current animation
      this.animation.cancel();
    }

    // Start a WAAPI animation
    this.animation = this.el.animate({
      // Set the keyframes from the startHeight to endHeight
      height: [startHeight, endHeight]
    }, {
      duration: 400,
      easing: 'ease-out'
    });
    // When the animation is complete, call onAnimationFinish()
    this.animation.onfinish = () => this.onAnimationFinish(true);
    // If the animation is cancelled, isExpanding variable is set to false
    this.animation.oncancel = () => this.isExpanding = false;
  }

  onAnimationFinish(open) {
    // Set the open attribute based on the parameter
    this.el.open = open;
    // Clear the stored animation
    this.animation = null;
    // Reset isClosing & isExpanding
    this.isClosing = false;
    this.isExpanding = false;
    // Remove the overflow hidden and the fixed height
    this.el.style.height = this.el.style.overflow = '';
  }
}

document.querySelectorAll('details:not(.grouped-accordion):not(.search-details)').forEach((el) => {
  new Accordion(el);
});

class AccordionsGroup {
  constructor(el) {
    // Store the <details> element
    this.el = el;
    // Store the <summary> element
    this.summary = el.querySelector('summary');
    // Store the <div class="content"> element
    this.content = el.querySelector('.accordion__content');
    // Store the parent container
    this.parent = el.closest('.accordions-group');

    // Store the animation object (so we can cancel it if needed)
    this.animation = null;
    // Store if the element is closing
    this.isClosing = false;
    // Store if the element is expanding
    this.isExpanding = false;
    // Detect user clicks on the summary element
    this.summary.addEventListener('click', (e) => this.onClick(e));
  }

  onClick(e) {
    // Stop default behaviour from the browser
    e.preventDefault();
    // Add an overflow on the <details> to avoid content overflowing
    this.el.style.overflow = 'hidden';
    // Check if the element is being closed or is already closed
    if (this.isClosing || !this.el.open) {
      this.open();
    // Check if the element is being openned or is already open
    } else if (this.isExpanding || this.el.open) {
      this.shrink();
    }
  }

  shrink() {
    this.el.style.overflow = 'hidden';
    // Set the element as "being closed"
    this.isClosing = true;

    // Store the current height of the element
    const startHeight = `${this.el.offsetHeight}px`;
    // Calculate the height of the summary
    const endHeight = `${this.summary.offsetHeight}px`;

    // If there is already an animation running
    if (this.animation) {
      // Cancel the current animation
      this.animation.cancel();
    }

    // Start a WAAPI animation
    this.animation = this.el.animate({
      // Set the keyframes from the startHeight to endHeight
      height: [startHeight, endHeight]
    }, {
      duration: 400,
      easing: 'ease-out'
    });

    // When the animation is complete, call onAnimationFinish()
    this.animation.onfinish = () => this.onAnimationFinish(false);
    // If the animation is cancelled, isClosing variable is set to false
    this.animation.oncancel = () => this.isClosing = false;
  }

  open() {
    // Close other open details elements in the parent container
    this.closeOtherAccordions();

    // Apply a fixed height on the element
    this.el.style.height = `${this.el.offsetHeight}px`;
    // Force the [open] attribute on the details element
    this.el.open = true;
    // Wait for the next frame to call the expand function
    window.requestAnimationFrame(() => this.expand());
  }

  expand() {
    // Set the element as "being expanding"
    this.isExpanding = true;
    // Get the current fixed height of the element
    const startHeight = `${this.el.offsetHeight}px`;
    // Calculate the open height of the element (summary height + content height)
    const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

    // If there is already an animation running
    if (this.animation) {
      // Cancel the current animation
      this.animation.cancel();
    }

    // Start a WAAPI animation
    this.animation = this.el.animate({
      // Set the keyframes from the startHeight to endHeight
      height: [startHeight, endHeight]
    }, {
      duration: 400,
      easing: 'ease-out'
    });
    // When the animation is complete, call onAnimationFinish()
    this.animation.onfinish = () => this.onAnimationFinish(true);
    // If the animation is cancelled, isExpanding variable is set to false
    this.animation.oncancel = () => this.isExpanding = false;
  }

  closeOtherAccordions() {
    // Find all sibling details elements
    const siblings = this.parent.querySelectorAll('details');
    siblings.forEach((sibling) => {
      if (sibling !== this.el && sibling.open) {
        const siblingAccordion = sibling.querySelector('summary').accordionInstance;
        if (siblingAccordion) {
          siblingAccordion.shrink();
        }
      }
    });
  }

  onAnimationFinish(open) {
    // Set the open attribute based on the parameter
    this.el.open = open;
    // Clear the stored animation
    this.animation = null;
    // Reset isClosing & isExpanding
    this.isClosing = false;
    this.isExpanding = false;
    // Remove the overflow hidden and the fixed height
    this.el.style.height = this.el.style.overflow = '';
  }
}

const accordionGroups = document.querySelectorAll('.accordions-group');
accordionGroups.forEach((group) => {
  group.querySelectorAll('details.grouped-accordion').forEach((el) => {
    const accordion = new AccordionsGroup(el);
    el.querySelector('summary').accordionInstance = accordion;
  });
});

// Gorgias chat position code

window.addEventListener('DOMContentLoaded', () => {
  let wasShown = false;

  const footerObserver = new IntersectionObserver((entries) => {
    const chatButton = document.querySelector('#chat-button');
    const chatButtonWidth = chatButton.offsetWidth;
    const chatButtonHeight = chatButton.offsetHeight;
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        chatButton.style = `right: 20px; bottom: -100px !important; visibility: visible; width: ${chatButtonWidth}px; height: ${chatButtonHeight}px;`;
      } else if (!entry.isIntersecting && wasShown) {
        chatButton.style = `right: 20px; bottom: 20px !important; visibility: visible; width: ${chatButtonWidth}px; height: ${chatButtonHeight}px;`;
      }
    });
  });

  const firstSectionObeserver = new IntersectionObserver((entries) => {
    const chatButton = document.querySelector('#chat-button');
    const chatButtonWidth = chatButton.offsetWidth;
    const chatButtonHeight = chatButton.offsetHeight;
    entries.forEach((entry) => {
      if (entry.isIntersecting && !wasShown) {
        chatButton.style = `right: 20px; bottom: -100px !important; visibility: visible; width: ${chatButtonWidth}px; height: ${chatButtonHeight}px;`;
      } else {
        chatButton.style = `right: 20px; bottom: 20px !important; visibility: visible; width: ${chatButtonWidth}px; height: ${chatButtonHeight}px;`;
        wasShown = true;
      }
    });
  });

  function moveGorgiasChatRecursive(timeoutInSeconds) {
    const startTime = Date.now();
    const timeout = timeoutInSeconds * 1000; // Convert seconds to milliseconds

    function searchAndStyle() {
      const element = document.querySelector('#chat-button');

      if (element) {
        const footer = document.querySelector('footer');
        const firstSection = document.querySelector('main > *:first-child');
        footerObserver.observe(footer);
        firstSectionObeserver.observe(firstSection);
      } else if (Date.now() - startTime < timeout) {
        // If the element doesn't have a shadowRoot yet and the timeout hasn't elapsed, retry
        setTimeout(searchAndStyle, 100); // You can adjust the delay as needed
      } else {
        // If the timeout has elapsed and the element is still not found, return
        console.log('gorgias chat button not found');
      }
    }

    // Start the search
    searchAndStyle();
  }

  // Start the recursive process with a 5-second timeout
  moveGorgiasChatRecursive(10);
});